import { useRegisterUser } from './useRegisterUser';
import { useValidationForm } from './useValidationForm';
import { useRecaptcha } from './useRecaptcha';
import { useHistory } from 'react-router-dom';
import { APP_PATH_REGISTRATION_SUCCESS, APP_PATH_ROOT } from '../config';
import zxcvbn from 'zxcvbn';

const schemaToValidate = {
  fullName: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      minimum: 2,
      maximum: 100,
      message: 'must be between 2 and 100 characters'
    }
  },
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  },
  policy: {
    presence: { allowEmpty: false, message: 'is required' },
    checked: true
  }
};

export const useSignUp = () => {
  const history = useHistory();
  const { handleChange, hasError, formState } = useValidationForm({
    schemaToValidate
  });
  const { registerUser } = useRegisterUser();
  const { executeRecaptcha } = useRecaptcha();

  const handleBack = () => {
    history.push(APP_PATH_ROOT);
  };

  // Check if password meets minimum strength requirement (Fair or better)
  const isPasswordStrongEnough = () => {
    const password = formState.values.password;
    if (!password) return false;

    const result = zxcvbn(password);
    return result.score >= 2; // Minimum "Fair" (score 2)
  };

  const handleSignUp = async (formState) => {
    const {
      values: { fullName, email, password }
    } = formState;
    if (fullName && email && password) {
      try {
        // Execute reCAPTCHA before registration
        const recaptchaToken = await executeRecaptcha('register');

        const result = await registerUser({
          fullName,
          email,
          password,
          username: email.split('@').join('_'),
          recaptchaToken
        });

        // Check if registration was successful
        if (result?.data?.data?.id) {
          // Redirect to the registration success page
          history.push(APP_PATH_REGISTRATION_SUCCESS);
        }
      } catch (error) {
        // Error is already handled in the usersApiSlice
        console.error('Registration error:', error);
      }
    }
  };

  return {
    handleSignUp,
    handleChange,
    handleBack,
    hasError,
    formState,
    isPasswordStrongEnough
  };
};
